import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { LocaleExceptionsResultModel } from "../models/LocaleExceptionsResultModel";
import { LocaleExceptionsModel } from "../models/LocaleExceptionsModel";


@Injectable({ providedIn: "root" })

export class LocaleExceptionsService {
  constructor(private http: HttpClient) {
  }

  getLanguageCodes() {
    return this.http.get<any[]>(`${environment.api}/api/LocaleException/`);
  }

  getAllTranslatedValues(id: number) {
    return this.http.get<LocaleExceptionsResultModel>(`${environment.api}/api/LocaleException/translated/${id}`);
  }
  getTranslatedText(id: number, code: string, displayName: string) {

    return this.http.get(`${environment.api}/api/LocaleException/${id}/${code}/${displayName}`, { responseType: 'text' });
  }
  saveTranslatedText(translate: LocaleExceptionsModel) {
    return this.http.post<LocaleExceptionsModel>(`${environment.api}/api/LocaleException`, translate);
  }
  deleteTranslate(id: number, translate: string) {
    return this.http.delete<LocaleExceptionsModel[]>(`${environment.api}/api/LocaleException/${id}/${translate}`);
  }
}
